module.exports = __webpack_public_path__ + "img/faming8.67d0d556.png";